import type {
  CopilotContext,
  CopilotContextDataEntry,
  CopilotContextRef,
  CopilotResourceRef,
} from "src/clients/agent-management";
import type {
  ContextualEntity,
  ContextualEntityRef,
  InlineContextualEntity,
  ReferenceContextualEntity,
} from "src/unifiedCopilot/context/types";
import { contextualEntityKey } from "src/unifiedCopilot/context/types";

const isReferenceContextualEntity = (
  entity: ContextualEntity,
): entity is ReferenceContextualEntity => entity.kind === "reference";

const isInlineContextualEntity = (
  entity: ContextualEntity,
): entity is InlineContextualEntity => entity.kind === "inline";

export const mapContextualEntityRefToResourceRef = (
  ref: ContextualEntityRef,
): CopilotResourceRef => ({
  type: ref.type,
  id: ref.id,
  ...(ref.parent
    ? { parent: mapContextualEntityRefToResourceRef(ref.parent) }
    : {}),
});

export const mapReferenceContextualEntityToCopilotResourceRef = (
  entity: ReferenceContextualEntity,
): CopilotResourceRef => ({
  type: entity.type,
  id: entity.id,
  ...(entity.parent
    ? { parent: mapContextualEntityRefToResourceRef(entity.parent) }
    : {}),
});

export const mapContextualEntitiesToCopilotRefs = (
  entities: ContextualEntity[],
): CopilotContextRef[] =>
  entities.filter(isReferenceContextualEntity).map((entity) => ({
    ...mapReferenceContextualEntityToCopilotResourceRef(entity),
    label: entity.displayName,
  }));

export const mapContextualEntitiesToCopilotData = (
  entities: ContextualEntity[],
): CopilotContextDataEntry[] =>
  entities.filter(isInlineContextualEntity).map((entity) => ({
    key: contextualEntityKey(entity),
    value: entity.content,
    description: entity.displayName,
  }));

export const mapContextualEntitiesToCopilotContext = (
  entities: ContextualEntity[],
): CopilotContext => ({
  refs: mapContextualEntitiesToCopilotRefs(entities),
  data: mapContextualEntitiesToCopilotData(entities),
});
